/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/ZeroDataItem.Props" />
import { IZeroDataItem } from "VSSUI/ZeroData";

export interface IZeroDataItemProps {
    item: IZeroDataItem;
}